import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=c80787d2&scoped=true&"
import script from "./ProductTile.vue?vue&type=script&lang=js&"
export * from "./ProductTile.vue?vue&type=script&lang=js&"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=c80787d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80787d2",
  null
  
)

export default component.exports